import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, startWith } from 'rxjs';
import { isNotificationsRulesNavActive } from '@app/pages/admin/admin-notifications-routes.util';
import { AdminNotificationsCatalogQuery } from './admin-notifications-catalog-query';

@Component({
  selector: 'app-admin-notifications-shell',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  templateUrl: './admin-notifications-shell.html',
  styleUrl: './admin-notifications-shell.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdminNotificationsCatalogQuery],
})
export class AdminNotificationsShellComponent {
  private readonly router = inject(Router);

  readonly rulesNavActive = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith(null),
      map(() => isNotificationsRulesNavActive(this.router.url)),
    ),
    { initialValue: isNotificationsRulesNavActive(this.router.url) },
  );

  readonly links = [
    {
      label: 'adminNotifications.rules',
      icon: 'pi pi-list-check',
      url: '/admin/orchestration/notifications',
      rulesNav: true,
    },
    {
      label: 'adminNotifications.templates',
      icon: 'pi pi-file-edit',
      url: '/admin/orchestration/notifications/templates',
    },
    {
      label: 'adminNotifications.messages',
      icon: 'pi pi-inbox',
      url: '/admin/orchestration/notifications/messages',
    },
    {
      label: 'adminNotifications.journal',
      icon: 'pi pi-book',
      url: '/admin/orchestration/notifications/journal',
    },
    {
      label: 'adminNotifications.settings',
      icon: 'pi pi-cog',
      url: '/admin/orchestration/notifications/settings',
    },
  ];
}
